import React, { forwardRef, type TextareaHTMLAttributes } from 'react';
import classnames from 'classnames';
import styled from 'styled-components';

interface Props extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  scheme?: 'dark' | 'light';
  warning?: boolean;
}

const InnerTextarea = styled.textarea<Pick<Props, 'scheme'>>`
  &::-webkit-scrollbar {
    background-color: transparent;
    width: 12px;
  }

  &::-webkit-scrollbar-track {
    background-color: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${({ scheme }) =>
      scheme === 'light' ? '#D8D8D8' : '#545454'};
    border-radius: 99px;
    cursor: pointer;
    background-clip: padding-box;
    border: 4px solid transparent;
  }

  &::-webkit-scrollbar-button {
    display: none;
  }
`;

const Textarea = forwardRef<HTMLTextAreaElement, Props>((props, ref) => {
  const { className, scheme = 'light', warning = false, ...rest } = props;
  const displayCount = !!rest.maxLength;
  const cx = classnames(
    'resize-none w-full h-full pt-10 px-10 rounded border focus:outline-none focus:ring-2 focus:ring-blue',
    {
      'bg-white': scheme === 'light',
      'bg-black border-dark': scheme === 'dark',
      'ring-2 ring-red': warning,
      'pb-30': displayCount,
      'pb-10': !displayCount,
    }
  );

  const renderCount = () => {
    const val = String(rest.value || '');
    const count = `${val.length}/${rest.maxLength}`;

    const countCx = classnames('absolute right-10 bottom-10 h-20 px-5', {
      'text-red': val.length >= rest.maxLength!,
      'text-black-gray': val.length < rest.maxLength!,
      'bg-black-#28': scheme === 'dark',
      'bg-white-border': scheme === 'light',
    });
    return <div className={countCx}>{count}</div>;
  };
  return (
    <div className={classnames('relative', className)}>
      <InnerTextarea ref={ref} scheme={scheme} className={cx} {...rest} />
      {displayCount && renderCount()}
    </div>
  );
});

export default Textarea;
